import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import NoSsr from '@material-ui/core/NoSsr';
import MuiFormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import styled from 'styled-components';
import { media } from 'theme/styled-theme';

const StyledOutlineInput = withStyles({
  root: {
    'label + &': {
      marginTop: 0,
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: 'white',
    fontSize: 16,
    width: 'auto',
    border: '1px solid #dbdbdb',
    padding: '15px 26px 14px 12px',
  },
})(OutlinedInput);

const FormControl = styled(MuiFormControl)`
  && {
    margin: 0 0.5rem 0 0;

    ${media.forPhoneOnly`
      margin-left: 0;
    `}
  }
`;
const CountrySelect = ({ onChange, country }) => {
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);

  React.useEffect(() => {
    setLabelWidth(inputLabel.current?.offsetWidth);
  }, []);

  return (
    <NoSsr>
      <FormControl>
        <Select
          value={country}
          onChange={e => onChange(e.target.value)}
          displayEmpty
          name="country"
          input={<StyledOutlineInput labelWidth={labelWidth} name="age" id="outlined-age-simple" />}
        >
          <MenuItem value="tw">Taiwan</MenuItem>
          <MenuItem value="th">Thailand</MenuItem>
        </Select>
      </FormControl>
    </NoSsr>
  );
};

CountrySelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
};

export default CountrySelect;
